import { openBlock as t, createElementBlock as l, createStaticVNode as a } from "vue";
const h = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, e = /* @__PURE__ */ a('<path fill="#F0F0F0" d="M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"></path><path fill="#0052B4" d="M37.568 10.435A20.045 20.045 0 0 0 25.218.688l-.87 9.747h13.22Zm-35.136 0h13.22l-.87-9.747a20.045 20.045 0 0 0-12.35 9.747Z"></path><path fill="#6DA544" d="M24.348 20v9.565h13.22A19.91 19.91 0 0 0 40 20H24.348Zm-8.696 0H0a19.9 19.9 0 0 0 2.432 9.565h13.22V20Z"></path><path fill="#FFDA44" d="M2.432 29.565a20.045 20.045 0 0 0 12.35 9.747l.87-8.524-13.22-1.223Zm22.785 9.747a20.045 20.045 0 0 0 12.351-9.747l-13.22 1.223.87 8.524Z"></path><path fill="#FFDA44" d="m24.348 30.788 13.22-1.223h-13.22v1.223Zm-8.696-1.223H2.432l13.22 1.223v-1.223Z"></path><path fill="#D80027" d="M20 0c-1.805 0-3.554.24-5.217.689v38.622A19.99 19.99 0 0 0 20 40c1.805 0 3.554-.24 5.217-.689V.689A20.022 20.022 0 0 0 20 0Z"></path><path fill="#FFDA44" d="m10.758 4.348.54 1.66h1.745l-1.412 1.027.54 1.66-1.413-1.026-1.413 1.027.54-1.661-1.413-1.026h1.746l.54-1.661Z"></path>', 7), c = [
  e
];
function p(o, i) {
  return t(), l("svg", h, [...c]);
}
const d = { render: p };
export {
  d as default,
  p as render
};
